import {
  IsBoolean,
  IsDateString,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'

/**
 * DTO pour modifier une adhésion de classe
 */
export class UpdateClassMembershipDto {
  @ApiPropertyOptional({ type: 'string', description: 'ID classe' })
  @IsOptional()
  @IsString()
  classId?: string

  @ApiPropertyOptional({ type: 'string', description: 'ID utilisateur' })
  @IsOptional()
  @IsString()
  userId?: string

  @ApiPropertyOptional({ type: 'string', description: 'ID rôle' })
  @IsOptional()
  @IsUUID('4')
  roleId?: string

  @ApiPropertyOptional({ type: Boolean, description: 'Délégué de classe' })
  @IsOptional()
  @IsBoolean()
  isHead?: boolean

  @ApiPropertyOptional({ type: 'string', description: "Date d'adhésion" })
  @IsOptional()
  @IsDateString()
  joinedAt?: string

  @ApiPropertyOptional({ type: 'string', description: 'Date de départ' })
  @IsOptional()
  @IsDateString()
  leftAt?: string

  @ApiPropertyOptional({ type: Boolean, description: 'Actif' })
  @IsOptional()
  @IsBoolean()
  isActive?: boolean
}
